import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import RspLayout from "../container/rsp/overview/RspLayout";
const RspHome = lazy(() => import("../container/rsp/RspHome"));

const FrontendRoutes = React.memo(() => {
  return (
    <Routes>
      <Route path="*" element={<RspHome />} />
    </Routes>
  );
});

export default RspLayout(FrontendRoutes);
